// extracted by mini-css-extract-plugin
export var label = "_i2-2";
export var slideContainer = "_i2-0";
export var slider = "_i2-1";